(() => {
  const isSupporthubPage = document.querySelectorAll('.ph-page-supporthub');

  /**
   * Hiding the list of questions on clicking the boxes
   */

  const hideComponent = (boxes, hiddenClass) => {
    boxes.forEach((hideEle) => {
      hideEle.classList.add(hiddenClass);
    });
  };

  /**
   * Showing the boxes on clicking All help topics link
   */

  const showComponent = (boxes, hiddenClass) => {
    boxes.forEach((showEle) => {
      showEle.classList.remove(hiddenClass);
    });
  };

  const supportContent = () => {
    const boxes = document.querySelectorAll('.ph-helptopicscategories__parent > .ph-helptopicscategories__boxes'),
        questionTitle =
        document.querySelectorAll('.ph-helptopicscategories__parent > .ph-helptopicscategories__questions > .ph-helptopicscategories_questiontitle'),
        backClick = document.querySelectorAll('.ph-helptopicscategories__parent > .ph-helptopicscategories__questions'),
        containerLength = document.querySelector('.ph-helptopicscategories__parent').textContent.trim().length,
        supportHeader = 'ph-supporthub__header',
        questionColor = 'ph-helptopicscategories__questioncolorchange',
        upArrow = 'ph-helptopicscategories__uparrow',
        downArrow = 'ph-helptopicscategories__downarrow',
        hiddenClass = 'hidden',
        searchBox = 'ph-supporthub__search',
        helptopicsText = document.querySelector('.ph-helptopics').textContent;

    if (containerLength > 0) {
      document.querySelector(`.${supportHeader}`).prepend(helptopicsText);
      document.querySelector(`.${searchBox}`).classList.remove(hiddenClass);
    }

    /**
     * Iterating the boxes and hiding them, and also showing the list of questions
     */

    boxes.forEach((entry) => {
      entry.addEventListener('click', (element) => {
        hideComponent(boxes, hiddenClass);
        element.currentTarget.nextElementSibling.classList.remove(hiddenClass);
        document.querySelector(`.${supportHeader}`).classList.add(hiddenClass);
      });
    });

    /**
     * Iterating the link All help topics, this calls the showComponent which hides the list of questions and shows the boxes.
     */

    backClick.forEach((ent) => {
      ent.firstElementChild.addEventListener('click', () => {
        boxes.forEach((entry) => {
          showComponent(boxes, hiddenClass);
          entry.nextElementSibling.classList.add(hiddenClass);
          document.querySelector(`.${supportHeader}`).classList.remove(hiddenClass);
        });
      });
    });

    /**
     * Iterating the list of questions to show the answers in accordion and toggling them. Also, toggling the same on clicking the close link.
     */

    questionTitle.forEach((currentQuestion) => {
      currentQuestion.addEventListener('click', (elements) => {
        elements.target.nextElementSibling.classList.toggle(hiddenClass);
        elements.target.classList.toggle(questionColor);
        elements.target.classList.toggle(upArrow);
        elements.target.classList.toggle(downArrow);
      });
      currentQuestion.nextElementSibling.lastElementChild.addEventListener('click', (closeClick) => {
        closeClick.target.parentElement.classList.add(hiddenClass);
        closeClick.target.parentElement.previousElementSibling.classList.toggle(upArrow);
        closeClick.target.parentElement.previousElementSibling.classList.toggle(questionColor);
        closeClick.target.parentElement.previousElementSibling.classList.toggle(downArrow);
      });
    });
  };

  if (isSupporthubPage.length > 0) {
    supportContent();
  }
})();
